import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import {
  get_native16zxqjg6lrtlz as get_native,
  Job$cancel$ref2r8rkxbnqcz6i as Job$cancel$ref,
} from '../NativeElement.commonHtml.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Duration__toString_impl_8d916b1pmuuqkmfodll as Duration__toString_impl_8d916b,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../Element.ext.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { lastOrNull1aq5oz189qoe1 as lastOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  delay2kng7ucb3aj62 as delay,
  delayp0o4nsccwai as delay_0,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function nativeSwap(_this__u8e3s4, transition, createNewView) {
  var keyframeName = _this__u8e3s4.get_context_h02k06_k$().kiteUiCss_1.transition_pc86d7_k$(transition);
  var transitionTime = get_theme(_this__u8e3s4).transitionDuration_1;
  var easing = transition.easing_1;
  var easingCss = 'cubic-bezier(' + easing.x1__1 + ', ' + easing.y1__1 + ', ' + easing.x2__1 + ', ' + easing.y2__1 + ')';
  var tmp0_safe_receiver = _this__u8e3s4.previousLast_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
    var this_0 = get_native(tmp0_safe_receiver);
    var tmp0_safe_receiver_0 = this_0.element_1;
    var tmp;
    if (tmp0_safe_receiver_0 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      (tmp0_safe_receiver_0 instanceof HTMLElement ? tmp0_safe_receiver_0 : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
      tmp = Unit_instance;
    }
    if (tmp == null) {
      this_0.elementToDo_1.add_utx5q5_k$((it) => {
        (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
        return Unit_instance;
      });
    }
    launch(_this__u8e3s4, VOID, VOID, nativeSwap$slambda(_this__u8e3s4, tmp0_safe_receiver));
  }
  // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
  var tmp_0 = get_native(_this__u8e3s4).element_1;
  var tmp0_safe_receiver_1 = tmp_0 instanceof HTMLElement ? tmp_0 : null;
  var tmp_1;
  if (tmp0_safe_receiver_1 == null) {
    tmp_1 = null;
  } else {
    // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
    var this_1 = tmp0_safe_receiver_1;
    var animate = get_animationsEnabled();
    try {
      if (animate) {
        set_animationsEnabled(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = this_1.__suppressMutationObserverClass;
        var tmp0_elvis_lhs = tmp_2 instanceof ArrayList() ? tmp_2 : null;
        var tmp_3;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.js.asDynamic' call
          this_1.__suppressMutationObserverClass = n;
          tmp_3 = n;
        } else {
          tmp_3 = tmp0_elvis_lhs;
        }
        var e = tmp_3;
        this_1.classList.add('notransition');
        var tmp1_elvis_lhs = this_1.getAttribute('class');
        e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      createNewView(_this__u8e3s4);
    }finally {
      if (animate) {
        var tmp_4 = window;
        tmp_4.setTimeout(() => {
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
          var this_0 = this_1;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = this_0.__suppressMutationObserverClass;
          var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.js.asDynamic' call
            this_0.__suppressMutationObserverClass = n;
            tmp_0 = n;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var e = tmp_0;
          this_1.classList.remove('notransition');
          var tmp1_elvis_lhs = this_0.getAttribute('class');
          e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          return Unit_instance;
        }, 100);
        set_animationsEnabled(true);
      }
    }
    tmp_1 = Unit_instance;
  }
  if (tmp_1 == null) {
    createNewView(_this__u8e3s4);
  }
  // Inline function 'kotlin.takeUnless' call
  var this_2 = lastOrNull(_this__u8e3s4.get_children_4cwbp4_k$());
  var tmp_5;
  if (!equals(this_2, _this__u8e3s4.previousLast_1)) {
    tmp_5 = this_2;
  } else {
    tmp_5 = null;
  }
  var tmp1_safe_receiver = tmp_5;
  var tmp_6;
  if (tmp1_safe_receiver == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.let' call
    _this__u8e3s4.previousLast_1 = tmp1_safe_receiver;
    _this__u8e3s4.set_shown_mavbz5_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
    var this_3 = get_native(tmp1_safe_receiver);
    var tmp0_safe_receiver_2 = this_3.element_1;
    var tmp_7;
    if (tmp0_safe_receiver_2 == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      (tmp0_safe_receiver_2 instanceof HTMLElement ? tmp0_safe_receiver_2 : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
      tmp_7 = Unit_instance;
    }
    if (tmp_7 == null) {
      this_3.elementToDo_1.add_utx5q5_k$((it) => {
        (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' ' + easingCss + ' forwards';
        return Unit_instance;
      });
    }
    tmp_6 = Unit_instance;
  }
  if (tmp_6 == null) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.previousLast_1 = null;
    if (_this__u8e3s4.get_shown_iyiju0_k$()) {
      // Inline function 'com.lightningkite.kiteui.afterTimeout' call
      var milliseconds = _Duration___get_inWholeMilliseconds__impl__msfiry(transitionTime);
      var job = launch(_this__u8e3s4, VOID, VOID, nativeSwap$slambda_0(milliseconds, _this__u8e3s4));
      Job$cancel$ref(job);
    }
  }
}
function nativeSwap$slambda($this_nativeSwap, $view) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(get_theme($this_nativeSwap).transitionDuration_1, $completion);
    $this_nativeSwap.removeChild_kofmvd_k$($view);
    return Unit_instance;
  }), 1);
}
function nativeSwap$slambda_0($milliseconds, $$this$run) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay_0($milliseconds, $completion);
    $$this$run.set_shown_mavbz5_k$(false);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  nativeSwap as nativeSwapd14jid0qtx03,
};
//endregion

//# sourceMappingURL=SwapView.commonHtml.js.mjs.map
